import React from 'react';
import HeroHeadline from './HeroHeadline';
import HeroLead from './HeroLead';
import { useHeroSlides } from './heroSlides';
import { useHeroCycle } from './useHeroCycle';

// WU-HERO: the typed headline and its line, driven by one timer. The timer lives here, not in Hero,
// so each typing step re-renders only these two and never the calculator beside them.
const HeroMessage: React.FC = () => {
  const slides = useHeroSlides();
  const { reduced, cycle } = useHeroCycle(slides);
  return (
    <>
      <HeroHeadline slides={slides} cycle={cycle} reduced={reduced} />
      <HeroLead slides={slides} cycle={cycle} reduced={reduced} />
    </>
  );
};

export default HeroMessage;
